const _ = require('lodash');

const globalTargetName = '_global';

const NotificationService = function ($timeout) {
    this.$timeout = $timeout;

    // A dictionary of notification targets;
    this.targets = {};

    this.targets[globalTargetName] = {
        visible: false,
        message: '',
        classes: []
    };
};
NotificationService.prototype.showNotification = function (notification, target) {
    let classList = _([]);

    if (!target) {
        classList.push('notification--global');
    }

    classList = classList.concat(notification.classes);

    target = target || globalTargetName; // if target is falsey target the global notification area.

    this.targets[target].message = notification.message;
    this.targets[target].classes = classList.valueOf();
    this.targets[target].visible = true;

    if (notification.timeout) {
        this.$timeout(this.hideNotification.bind(this, target), notification.timeout);
    }
};

NotificationService.prototype.showErrorNotification = function (notification, target) {
    notification.classes.push('notification--error');

    return this.showNotification(notification, target);
};

NotificationService.prototype.hideNotification = function (target) {
    target = target || globalTargetName;

    this.targets[target].visible = false;
};

NotificationService.prototype.registerNotficationTarget = function (target) {
    target = target || globalTargetName;
    if (!(target in this.targets)) {
        this.targets[target] = {
            visible: false,
            message: '',
            classes: []
        };
    }

    return this.targets[target];
};

module.exports = NotificationService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/notification/notification-service.js
 **/